import { TestScoresSummary, TestScores } from '../../../interfaces/DataQcInterface';
import { getTestScoresSummary } from '../../../services/dataQcSummaryService';
import useSchools from '../../hooks/useSchools';
import CustomDivider from '../../reusable/CustomDivider';
import DataQcCardInfoGrid, { Item } from '../cte courses/DataQcCardInfoGrid';
import WithDataWrapper from '../../reusable/WithDataWrapper';

import './TestScoresContent.css';

interface TestScoresContentProps {
  data: TestScoresSummary;
}

const labels: { [key: string]: string } = {
  sat_act_score_count: 'SAT/ACT superscores',
  sat_score_count: 'SAT superscores',
  act_score_count: 'ACT superscores'
};

function TestScoresContent({data}: TestScoresContentProps) {
  
  const testScoresSummary = data;

  const getItems = (testScores: TestScores) => {
    let items: Item[] = [];
    
    Object.entries(testScores).forEach(([key, value]) => {
      if (labels.hasOwnProperty(key)) items.push({ label: labels[key], value });
    });

    return items;
  };

  const cohortItems = getItems(testScoresSummary.cohort);

  const allStudentsItems = getItems(testScoresSummary.total);

  return (
    <div className="test-scores-content">
      <p className="test-scores-section-title">EOAA Cohort</p>
      <div data-testid="cohort-students-test-scores">
        <DataQcCardInfoGrid items={cohortItems} compact={true} />
      </div>
      <CustomDivider orientation="horizontal"/>
      <p className="test-scores-section-title">All students</p>
      <div data-testid="all-students-test-scores">
        <DataQcCardInfoGrid items={allStudentsItems} compact={true} />
      </div>
    </div>
  );
}

const TestScoresContentWithData = () => {
  
  const { dataQcSchool } = useSchools();

  let fetchData = (eoaId: string, access_token: string) => getTestScoresSummary(eoaId, access_token, dataQcSchool);

  return (
    <WithDataWrapper
      fetchData={fetchData}
      errorMessage="Error occurred while fetching test scores summary data!"
      initialState={{
        cohort: {
          act_score_count: 0,
          sat_act_score_count: 0,
          sat_score_count: 0
        },
        total: {
          act_score_count: 0,
          sat_act_score_count: 0,
          sat_score_count: 0
        }
      }}
      options={{
        dependencies: [dataQcSchool],
        areDependenciesRequired: false
      }}
    >
      {(data) => <TestScoresContent data={data} />}
    </WithDataWrapper>
  );
};

export default TestScoresContentWithData;